import InlineInput from '../modules/inline-input';
import Item from '../api/item';
import SVGIcons from '../modules/svgicons';
import delegateListener from '../modules/delegate-listener';
import { triggerEvent, openInNewWindow } from '../modules/dom-helpers';
import InfoBar from '../modules/info-bar';
import Delivery from '../api/delivery';
import DebounceCombiner from '../modules/debounce-combiner';
import ConfirmLeaving from '../modules/confirm-leaving';

const svgIcons = new SVGIcons();

/**
 * Initialize everything related to single item view
 */


/**
 * EVENTS
 *
 * ItemView class provides some custom events for other modules to attach to:
 *
 * Event name        | Triggered when...
 * ------------------|-------------------------------------------
 * step:completed    | a single step gets marked as 'COMPLETE'
 * step:incompleted  | a single step gets marked as 'INCOMPLETE'
 * stage:completed   | a single stage gets marked as 'COMPLETE'
 * stage:incompleted | a single stage gets marked as 'INCOMPLETE'
 * item:clearInfos   | information bars should be cleared. Specify event.detail.group to only hide bars belonging to that group
 *
 */

class ItemView {
  constructor(itemId) {
    this.item = new Item(itemId);

    // default location for info bar messages
    this.messageContainer = document.querySelector('.main__container');
    this.infoBarDefaults = {
      container: this.messageContainer,
      group: 'item'
    };
    this.invoicePageSelector = '.page--expense-list';

    this.confirmLeaving = new ConfirmLeaving();

    this.itemDebouncer = new DebounceCombiner({
      callback: data => {
        this.item.patch(data)
          .then(response => {
            this._updateStepStatuses(response);
            this._handleShouldRefreshChange(response);
            this.confirmLeaving.deactivate();
          });
      }
    });

    this.confirmClearDateMessage = 'Tahdotko varmasti nollata päivämäärän?';

    this.throttleTime = 1000;// delivery input throttling
  }

  init() {
    // bail early, if this is warehouse user's item view
    if(document.querySelector('.page--warehouse-item-view')) return;

    if(document.querySelector('button[data-default-for][data-default-value]')) {
      document.body.addEventListener('click', delegateListener(
        'button[data-default-for][data-default-value]',
        this._handleDefaultValueClick.bind(this))
      );
    }
    if (document.querySelector('.js-delete-item')) {
      const deleteHandler = this._deleteItem.bind(this);
      document.querySelectorAll('.js-delete-item').forEach(button => {
        button.addEventListener('click', deleteHandler);
      });
    }

    if (document.querySelector('.js-send-item-to-webshop')) {
      const sendToWebshopHandler = this._sendItemToWebshop.bind(this);
      document.querySelectorAll('.js-send-item-to-webshop').forEach(button => {
        button.addEventListener('click', sendToWebshopHandler);
      });
    }

    if (document.querySelector('.js-remove-item-from-webshop')) {
      const RemoveFromWebshopHandler = this._removeItemFromWebshop.bind(this);
      document.querySelectorAll('.js-remove-item-from-webshop').forEach(button => {
        button.addEventListener('click', RemoveFromWebshopHandler);
      });
    }

    if (document.querySelector('.js-cancel-sale')) {
      const cancelSaleHandler = this._cancelSale.bind(this);
      document.querySelectorAll('.js-cancel-sale').forEach(button => {
        button.addEventListener('click', cancelSaleHandler);
      });
    }

    /*if (document.querySelector('.js-update-item-warehouse')) {
      document.body.addEventListener('change', delegateListener(
        '.js-update-item-warehouse',
        this._returnItemToWarehouse.bind(this))
      );
    }*/

    if(document.querySelector('[name="item__stage__handover__green_papers"]')) {
      document.body.addEventListener('change', delegateListener(
        '[name="item__stage__handover__green_papers"]',
        this._editGreenPapers.bind(this))
      );
    }

    if(
        document.querySelector('[name="item__stage__handover__green_papers_sent_timestamp"]') &&
        document.querySelector('.js-set-green-papers-sent')
      ) {
      document.body.addEventListener('click', delegateListener(
        '.js-set-green-papers-sent',
        this._editGreenPapersSentTimestamp.bind(this))
      );
    }

    if(document.querySelector('[name="unregistered_product"]')) {
      document.body.addEventListener('change', delegateListener(
        '[name="unregistered_product"]',
        this._editUnregisteredProduct.bind(this))
      );
    }

    if(document.querySelector('[name="consignment_sale"]')) {
      document.body.addEventListener('change', delegateListener(
        '[name="consignment_sale"]',
        this._editConsignmentSale.bind(this))
      );
    }

    if (!window.READ_ONLY) {
      if (document.getElementById('item__basic-info')) {
      // We are in the basic info editor

        // Initialize inline inputs for editing item's basic info
        new InlineInput({
          selectors: {
            container: '#item__basic-info .inline-input',
            display: '#item__basic-info .inline-input__display',
            input: '#item__basic-info .inline-input__input',
            select: '#item__basic-info .inline-input .single-select__select',
            save: '#item__basic-info .inline-input__save-button',
            edit: '#item__basic-info .inline-input__edit-button'
          },
          saveAction: this._saveBasicInfo.bind(this)
        }).init();

        // Initialize hide/show field buttons
        document.querySelectorAll('[data-hide-field]').forEach(this._bindHideShowButtonClickEvent.bind(this));

        // Bind click event of save button
        document.querySelector('.js-save-basic-data').addEventListener('click', this._saveBasicDataStatus.bind(this));

        /*
        if (document.querySelector('.js-autovista')) {
          document.querySelector('.js-autovista').addEventListener('click', this._fetchAutovistaData.bind(this));
        }
        */

        // Bind click event of trafi button
        document.querySelector('.js-trafi-vehicle').addEventListener('click', this._fetchTrafiVehicleData.bind(this));

        // Change event on client dropdown
        document.querySelector('.js-change-item-client').addEventListener('change', this._changeItemClient.bind(this));
      }

      // Bind events to input fields in each stage
      if (document.querySelector('[data-field]')) {
        const inputChangeHandler = this._handleInputChange.bind(this);

        const svtProcessContainer = document.getElementById('stages');

        if(svtProcessContainer) {
          // change occurs only onblur, need it sooner (this is throttled)
          svtProcessContainer.addEventListener('input', delegateListener(
            [
              'input[type="text"][data-field]',
              'input[type="number"][data-field]',
              'textarea[data-field]'
            ].join(),
            inputChangeHandler
          ));

          svtProcessContainer.addEventListener('change', delegateListener(
            [
              '.date-picker__input[data-field]',
              'input[type="checkbox"][data-field]:not([data-field=\'waiting_for_documents\'])',
              'input[type="radio"][data-field]',
              'select[data-field]',
              'input[type="hidden"][data-field]'
            ].join(),
            inputChangeHandler
          ));
        }
      }

      document.addEventListener('change', delegateListener(
        '.date-picker__input.flatpickr-input', this._handleFlatpickrChange.bind(this)
      ));

      // Validate threshold value
      const thresholdValidator = this._validateFallingPriceThreshold.bind(this);
      const thresholdElement = document.querySelector('#item__stage__sale__falling_price_threshold');
      if(thresholdElement) {
        thresholdElement.addEventListener('keyup', thresholdValidator);
        thresholdElement.addEventListener('paste', thresholdValidator);
        thresholdElement.addEventListener('change', thresholdValidator);
      }

      // Bind event to special field that saves to deliveries-db
      const warehouseKeysElement = document.querySelector('#item__warehouse_keys');
      if(warehouseKeysElement) {
        warehouseKeysElement.addEventListener('input', this._handleWarehouseKeysChange.bind(this));
      }

      // Bind click event to save and close buttons
      if(document.querySelector('.js-save-and-close')) {
        document.body.addEventListener('click',
          delegateListener('.js-save-and-close', this._saveAndClose.bind(this))
        );
      }

      if(document.querySelector('.js-activate-pending-from-client')) {
        document.querySelector('.js-activate-pending-from-client').addEventListener('click', this._activatePendingFromClient.bind(this));
      }

      if(document.querySelector('.js-save-pending-from-client-data')) {
        document.querySelector('.js-save-pending-from-client-data').addEventListener('click', this._savePendingFromClientData.bind(this));
      }

      // Bind clicks to "Archive item" button
      if(document.querySelector('.js-archive-item')) {
        document.querySelectorAll('.js-archive-item').forEach(button => {
          button.addEventListener('click', this._archiveItem.bind(this));
        }, this);
      }
      // Bind clicks to "Unarchive item" button
      if(document.querySelector('.js-unarchive-item')) {
        document.querySelectorAll('.js-unarchive-item').forEach(button => {
          button.addEventListener('click', this._unarchiveItem.bind(this));
        }, this);
      }
    }

    if (document.querySelector('[data-complete-stage]')) {
      document.body.addEventListener('click',
        delegateListener('[data-complete-stage]', this._completeStageHandler.bind(this))
      );
    }

    if(document.querySelector('[data-uncomplete-stage]')) {
      document.body.addEventListener('click',
        delegateListener('[data-uncomplete-stage]', this._uncompleteStageHandler.bind(this))
      );
    }

    if(document.querySelector('.page--item [data-target="new-window"]')) {
      document.body.addEventListener('click',
        delegateListener('[data-target="new-window"]', this._openLinkInNewWindow.bind(this))
      );
    }

    const webshopUsersSearchOutput = document.getElementById('webshopUsersSearchOutput');
    if (webshopUsersSearchOutput) {
      webshopUsersSearchOutput.addEventListener('click',
        delegateListener('.item-search__result__button', this._fillBuyerDetails.bind(this))
      );
    }
  }

  /**
   * Validates falling price threshold value before sending to server.
   * Clears value if it's not valid.
   *
   * @param {Event} event - The event object
   */
  _validateFallingPriceThreshold(event) {
    const minValue = 0;
    const maxValueField = document.querySelector('#item__stage__sale__falling_price_start');
    let maxValue = maxValueField ? maxValueField.value : false;
    let currentValue = event.target.value;
    let valid = true;

    if(currentValue.length === 0) {
      //No value, no use validating
      return;
    }

    //Format for comparison
    maxValue = parseFloat(maxValue.replace(',', '.'));
    currentValue = parseFloat(currentValue);

    if(isNaN(maxValue)) {
      maxValue = false;
    }

    if(isNaN(currentValue)) {
      currentValue = minValue;
    }

    if(currentValue <= minValue) {
      valid = false;
    }

    if(maxValue && currentValue >= maxValue) {
      valid = false;
    }

    if(!valid) {
      event.target.value = '';
    }
  }

  /**
   * Handle opening specific links into a new window, rather than a tab.
   *
   * @param {Event} event - The event object
   */
  _openLinkInNewWindow(event) {
    event.preventDefault();
    openInNewWindow(event.delegateTarget.href);
  }

  /**
   * Handle selecting a buyer from the search results
   *
   * @param {Event} event - The event object
   */
  _fillBuyerDetails(event) {
    const target = event.delegateTarget;
    const saleDirectBuyerInput = document.getElementById('sale_direct_buyer');
    saleDirectBuyerInput.value = target.dataset.userPid;
    const saleDirectBuyerLabel = document.querySelector(`label[for="${saleDirectBuyerInput.id}"]`);
    saleDirectBuyerLabel.innerText = target.dataset.userEmail;
    saleDirectBuyerInput.dispatchEvent(new Event('change', {
      bubbles: true,
      target: saleDirectBuyerInput,
      delegateTarget: saleDirectBuyerInput
    }));
    document.getElementById('webshopUsersSearchInput').value = target.dataset.userEmail;
    document.getElementById('webshopUsersSearchOutput').innerHTML = '';
  }

  /**
   * Triggers a custom item:clearInfos event
   *
   * @param {String} [group] - InfoBar group, default is 'item'
   * @param {HTMLElement} [container] - The element where the infobar should be appended into
   */
  _triggerClearInfoEvent(group, container) {
    const event = new CustomEvent('item:clearInfos', {
      bubbles: true, detail: { group: group || this.infoBarDefaults.group }
    });
    (container || this.infoBarDefaults.container).dispatchEvent(event);
  }

  /**
   * Shorthand wrapper for displaying an infobar with item page's default settings
   *
   * @param {String|Array} text - The plaintext error message
   * @param {String} type - The infobar type [error/warning/check]
   * @param {Boolean} shouldRefresh - Whether the bar should include a refresh button
   */
  _showInfo(text, type, shouldRefresh = false) {
    if(Array.isArray(text)) {
      text = text.join(', ');
    }
    const infoBarOptions = Object.assign({}, this.infoBarDefaults, { text, type, shouldRefresh });
    new InfoBar(infoBarOptions);
  }

  /**
   * Mark an item as deleted
   *
   * @param {Object} event - The initiating event object
   */
  _deleteItem(event) {
    this._triggerClearInfoEvent();

    // A confirm will do for now, consider custom modals later
    /* eslint-disable no-alert */
    const confirmation = confirm(event.currentTarget.dataset.confirmMessage);
    /* eslint-enable no-alert */

    if(!confirmation) { return; }

    this.item.delete().then((data) => {
      if(data.status === 'OK') {
        window.location = '/';
      } else {
        this._showInfo(data.messages, 'error');
      }
    }, (reason) => {
      this._showInfo(reason, 'error');
    });
  }

  /**
   * Mark an item as archived
   */
  _archiveItem() {
    this._triggerClearInfoEvent();

    this.item.archive().then(value => {
      if(document.querySelector(this.invoicePageSelector)) {
        // This button is also shown on Item Invoices page, but there
        // we want to refresh the view, rather than return to index.
        document.location.reload()
      } else {
        window.location = '/';
      }
    }, reason => {
      this._showInfo(reason, 'error');
    });
  }

  /**
   * Unmark an item as archived
   */
  _unarchiveItem() {
    this._triggerClearInfoEvent();

    this.item.unarchive().then(value => {
      window.location.reload();
    }, reason => {
      this._showInfo(reason, 'error');
    });
  }

  /**
   * Changes item's order's green papers
   */
  _editGreenPapers() {
    let value = '';
    let localized;
    document.querySelectorAll('[name="item__stage__handover__green_papers"]').forEach(item => {
      if(item.checked) {
        value = item.value;
        localized = (item.labels[0] || {}).innerText;
      }
    });

    this.item.updateOrder({
      green_papers: value,
      green_papers__localized: localized
    })
    .then(data => {
      if(data.status === 'OK') {
        window.location.reload();
      } else {
        this._triggerClearInfoEvent();
        this._showInfo(data.messages, 'warning');
      }
    })
    .catch(reason => {
      this._triggerClearInfoEvent();
      this._showInfo(reason, 'error');
    });
  }

  /**
   * Sets "green paper sent" timestamp.
   */
  _editGreenPapersSentTimestamp() {
    const existingTimestamp = document.querySelector('[name="item__stage__handover__green_papers_sent_timestamp"]');
    if(existingTimestamp && existingTimestamp.value) {
      // Don't overwrite an already existing timestamp (this is a "one and done" field).
      // Technically this is already blocked from the UI by disabling the button, but let's
      // ensure that doing stupid things will require stupid efforts.
      return;
    }
    
    const timestamp = Date.now().toString();
    
    this.item.updateOrder({
      green_papers_sent_timestamp: timestamp,
    })
    .then(data => {
      if(data.status === 'OK') {
        window.location.reload();
      } else {
        this._triggerClearInfoEvent();
        this._showInfo(data.messages, 'warning');
      }
    })
    .catch(reason => {
      this._triggerClearInfoEvent();
      this._showInfo(reason, 'error');
    });
  }

  /**
   * Changes item's 'unregistered product' status.
   * @param {Event} event - Change event on the checkbox
   * @returns {Promise<boolean|void>} - False if something failed, reloads or updates UI otherwise
   */
  async _editUnregisteredProduct(event) {
    const checkbox = event.target;
    const isChecked = checkbox.checked;
    const trafiButtons = document.querySelectorAll('.js-trafi-vehicle');

    this._triggerClearInfoEvent(); // Clear any existing alerts

    try {
      // 1. Update unregistered product field value
      const requestData = { unregistered_product: isChecked };
      const response = await this.item.patch(requestData);
      
      if (response.status !== 'OK') {
        this._showInfo(response.messages || 'Päivitys epäonnistui.', 'warning');
        checkbox.checked = !isChecked; // Revert UI
        return false;
      }

      // 2. If set to true, request archiving of trafi data
      if (isChecked) {
        const archiveResponse = await this.item.trafiArchive();
        
        if (archiveResponse.status !== 'OK') {
          this._showInfo(archiveResponse.messages || 'Trafi-tietojen arkistointi epäonnistui.', 'warning');
          
          // The first request succeeded but this one failed.
          // Roll back the database 'unregistered_product' status to keep things in sync.
          await this.item.patch({ unregistered_product: !isChecked });
          
          checkbox.checked = !isChecked; // Revert UI
          return false;
        }
        
        // Refresh view to eliminate trafi data from the page entirely
        location.reload();
        return;
      }

      // 3. Disable / enable trafi fetch buttons based on updated value (if not reloading)
      trafiButtons.forEach(button => {
        button.disabled = isChecked;
      });

    } catch (error) {
      // Handle network failures or server crashes
      this._showInfo(error, 'error');
      checkbox.checked = !isChecked; // Revert UI
      return false;
    }
  } 

  /**
   * Updates an item's consignment sale setting.
   * 
   * @param {Event} event - Change event on the checkbox
   */
  async _editConsignmentSale(event) {
    const checkbox = event.target;
    const isChecked = checkbox.checked;

    // Confirm, as consignment sale setting should never be updated
    // carelessly, as it has large consequences to the entire
    // sale process.
    // eslint-disable-next-line no-alert
    if (confirm('Oletko varma, että haluat muuttaa myyntimenettelyä?')) {
      
      this._triggerClearInfoEvent();

      try {
        const requestData = { consignment_sale: isChecked };
        const response = await this.item.patch(requestData);

        if (response.status === 'OK') {
          // Ensure UI reflects new state.
          window.location.reload();
        } else {
          // API errors
          this._showInfo(response.messages || 'Muutos epäonnistui.', 'warning');
          checkbox.checked = !isChecked; // Revert checkbox UI
        }
      } catch (error) {
        // Network/server errors
        this._showInfo(error, 'error');
        checkbox.checked = !isChecked;
      }

    } else {
      // User cancelled the confirmation dialog
      checkbox.checked = !isChecked;
    }
  }

  /**
   * Cancel sale
   */
  _cancelSale() {
    this._triggerClearInfoEvent();

    const cancelData = {};

    // Get reason for cancel
    const reasonField = document.querySelector('#item__stage__start_sale__cancel_sale_reason');

    if(reasonField) {
      const reason = reasonField.value;
      if(reason) {
        cancelData.reason = reason;
      }
    }

    this.item.cancelSale(cancelData).then(data => {
      if(data.status === 'OK') {
        this._showInfo(data.result, 'check');
        window.location.reload();
      } else {
        this._showInfo(data.messages, 'warning');
      }
    }, reason => {
      // Cancelling sale failed
      this._showInfo(reason, 'error');
    });
  }

  /**
   * Returns item to warehouse after cancelling sale
   *
   * @param {Event} event - Change event on the select dropdown
   */
  /*_returnItemToWarehouse(event) {
    this._triggerClearInfoEvent();

    const newWarehousePid = event.delegateTarget.value;

    if(newWarehousePid) {
      this.item.returnToWarehouse({warehouse: newWarehousePid}).then(data => {
        this._updateStepStatuses(data);
        if(data.status === 'OK') {
          location.reload();
        } else {
          this._showInfo(data.messages, 'warning');
        }
      }, reason => {
        this._showInfo(reason, 'error');
      });
    }
  }*/

  /**
   * Send item to webshop
   * @param {Event} event - The event object
   */
  _sendItemToWebshop(event) {
    const button = event.currentTarget;
    button.disabled = true;

    this._triggerClearInfoEvent();

    this.item.sendToWebshop().then((data) => {
      if (typeof data === 'object') {
        if (data.status === 'OK') {
          location.reload();
        }
        else {
          this._showInfo(data.messages, 'warning');
          button.disabled = false;
        }
      } else {
        this._showInfo(window.GENERIC_ERROR_MSG, 'error');
        button.disabled = false;
      }
    }, (reason) => {
      // sending item to webshop failed
      this._showInfo(reason, 'error');
      button.disabled = false;
    });
  }

  /**
   * Remove item from webshop
   */
  _removeItemFromWebshop() {
    this.item.removeFromWebshop().then((data) => {
      if (data.status === 'OK') {
        location.reload();
      }
      else {
        this._showInfo(data.messages, 'warning');
      }
    }, (reason) => {
      // removing item from webshop failed
      this._showInfo(reason, 'error');
    });
  }

  /**
   * Save and close the item.
   * This will open the lock of the item and redirect user to main view.
   *
   * @param {Event} event The click event of the save button
   */
  _saveAndClose(event) {
    const redirectURL = event.delegateTarget.getAttribute('data-redirect');

    this.item.unlock().then(response => {
      window.location.href = redirectURL;
    });
  }

  /**
   * Save the value of a field.
   *
   * @param {HTMLElement} source  The input element that was edited
   * @param {string}      value   The value of the input element
   * @returns {Boolean} - A truthy value, when field was saved successfully
   */
  async _saveBasicInfo(source, value) {
    const field = source.getAttribute('name');
    let labelText;

    if(source.tagName === 'SELECT') {
      const selectedOption = source.options[source.selectedIndex]
      labelText = selectedOption.innerText.trim();
    }

    const data = {};
    data[field] = value;
    if(labelText) {
      data[`${field}__localized`] = labelText;
    }

    const response = await this.item.patch(data);
  
    // Guard clause: Response status not "OK"
    if (response.status !== 'OK') return false;

    // Update accepted value column
    const acceptedValueTD = document.querySelector('[data-field-name="' + field + '"] .accepted-value');

    // 1. Traficom field has highest priority, except for license
    const trafiColumn = document.querySelector(`[data-field-name="${ field }"] .js-source-trafi`);
    const trafiValue = trafiColumn ? trafiColumn.querySelector('.js-field-value').innerHTML : null;
    if (trafiValue && field !== 'license') {
      acceptedValueTD.innerHTML = trafiValue;
      acceptedValueTD.classList.toggle('trafi-value', true);
      trafiColumn.querySelector('.source-indicator').classList.add('source-indicator--active');
      return true;
    }

    // 2. manual value has highest priority for license and second highest priority for everything else
    if (value) {
      // a. Localised name instead of value
      if(source.classList.contains('localised')) {
        acceptedValueTD.innerHTML = source.selectedOptions[0].innerText.trim();
        return true;
      } else {
        // b. Specified value
        acceptedValueTD.innerHTML = value;
      }

      // Deactivate active source indicators, since the manual value is the accepted one now
      const activeIndicator = document.querySelector(`[data-field-name="${ field }"] .source-indicator--active`);
      if(activeIndicator) {
        activeIndicator.classList.remove('source-indicator--active');
      }
      // Deactivate trafi value class if present
      acceptedValueTD.classList.toggle('trafi-value', false);
      return true;
    }

    // 2b. For license, trafi has second highest priority. trafiValue and trafiColumn were defined in step 1. 
    if (field === 'license' && trafiValue) {
      acceptedValueTD.innerHTML = trafiValue;
      acceptedValueTD.classList.toggle('trafi-value', true);
      trafiColumn.querySelector('.source-indicator').classList.add('source-indicator--active');
      return true;
    }

    // 3. ATJ value has third highest priority
    const atjColumn = document.querySelector('[data-field-name="' + field + '"] .js-source-atj');
    const atjValue = atjColumn ? atjColumn.querySelector('.js-field-value').innerHTML : null;

    if (atjValue) {
      acceptedValueTD.innerHTML = atjValue;
      atjColumn.querySelector('.source-indicator').classList.add('source-indicator--active');
      acceptedValueTD.classList.toggle('trafi-value', false);
      return true;
    }

    // 4. Fallback: Cabas value
    const cabasColumn = document.querySelector('[data-field-name="' + field + '"] .js-source-cabas');
    const cabasValue = cabasColumn ? cabasColumn.querySelector('.js-field-value').innerHTML : null;
    acceptedValueTD.innerHTML = cabasValue;
    acceptedValueTD.classList.toggle('trafi-value', false);

    if (cabasValue) {
      cabasColumn.querySelector('.source-indicator').classList.add('source-indicator--active');
    }
    return true;
  }

  /**
   * Changes master item client
   *
   * @param {Object} event - Select change event
   */
  _changeItemClient(event) {
    const clientOption = event.target.options[event.target.selectedIndex] || {};
    const clientText = (clientOption.innerText || '').trim();
    this.item.changeClient({
      client: event.target.value,
      client__localized: clientText
    }).then(response => {
      if(response.status === 'OK') {
        // TODO: maybe show success message?
      } else {
        // TODO: maybe show error message?
      }
    });
  }

  /**
   * Bind the click event of the hide/show button
   *
   * @param {HTMLElement} hideShowButton The button that was clicked
   */
  _bindHideShowButtonClickEvent(hideShowButton) {
    hideShowButton.addEventListener('click', this._hideShowField.bind(this));
  }

  /**
   * Hides or shows a certain field of the item according to a click event.
   *
   * @param {Event} event The click event of a hide/show field button
   */
  _hideShowField(event) {
    const INACTIVE_ROW_CLASS = 'datatable__row--inactive';
    const tableRow = event.currentTarget.parentNode.parentNode;
    const btn = event.currentTarget;

    if(btn.classList.contains('button--disabled')) {
      return;
    }

    if (tableRow.classList.contains(INACTIVE_ROW_CLASS)) {
      this.item.showField(tableRow.getAttribute('data-field-name')).then(result => {
        if (result.status === 'OK') {
          tableRow.classList.remove(INACTIVE_ROW_CLASS);
        }
      });
    }
    else {
      this.item.hideField(tableRow.getAttribute('data-field-name')).then(result => {
        if (result.status === 'OK') {
          tableRow.classList.add(INACTIVE_ROW_CLASS);
        }
      });
    }
  }

  /**
   * Changes the status of the step 'check basic data' as completed
   */
  _saveBasicDataStatus() {
    const missingFields = this._getMissingRequiredFields();
    if(missingFields.length) {
      const missingFieldNames = missingFields.map(el => el.dataset.required);
      // eslint-disable-next-line no-alert
      const continueSave = confirm(
        `Pakollisia tietoja puuttuu: ${ missingFieldNames.join(', ') }. Haluatko varmasti jatkaa?`
      );
      if(!continueSave) return;
    }

    this._triggerClearInfoEvent();

    this.item.updateStatus('check_item_info', 'check_item_info', 'COMPLETE').then(result => {
      if (result.status === 'OK') {
        // Move user back single item's main view
        window.location.href = window.ITEM_VIEW_URL;
      } else {
        this._showInfo(result.messages, 'error');
      }
    });
  }

  /**
   * Activates the stage "Pending from client"
   */
  _activatePendingFromClient() {


    /*

    const updateStepStatus = this._updateStepStatus.bind(this);
    this.item.updateStatus(stage, '', 'COMPLETE').then(result => {
      if (result.status === 'OK') {
        updateStepStatus(stage, '', 'COMPLETE');
      } else {
        this._showInfo(result.messages, 'error');
      }
    });

    */

    const updateStepStatus = this._updateStepStatus.bind(this);

    this.item.updateStatus('pending_from_client', 'waiting_for_documents', 'NOT_STARTED').then(result => {
      if (result.status === 'OK') {
        updateStepStatus('pending_from_client', 'waiting_for_documents', 'NOT_STARTED');
      } else {
        this._showInfo(result.messages, 'error');
      }
    });

    this.item.updateStatus('pending_from_client', 'pending_from_client_activated', 'INACTIVE').then(result => {
      if (result.status === 'OK') {
        updateStepStatus('pending_from_client', 'pending_from_client_activated', 'INACTIVE');
        updateStepStatus('pending_from_client', '', 'ERROR');
      } else {
        this._showInfo(result.messages, 'error');
      }
    });

  }

  /**
   * Saves the data about "Pending from client"
   */
  _savePendingFromClientData() {
    // 1. Query checked checkboxes and safe-fetch optional text input
    const checkedBoxes = Array.from(document.querySelectorAll('[data-field="waiting_for_documents"]'))
      .filter(checkbox => checkbox.checked);

    const otherInputElement = document.getElementById('item__stage__pending_from_client__other');
    const textInput = (otherInputElement && otherInputElement.value) ? otherInputElement.value.trim() : '';

    // 2. Prompt user if no checkboxes are selected
    if (!checkedBoxes.length) {
      // eslint-disable-next-line no-alert
      const continueSave = confirm(
        'Et ole valinnut mitään yhtiöstä odotettavaa dokumenttia! Haluatko varmasti jatkaa?'
      );
      if (!continueSave) return;
    }

    // 3. Extract localized label text for each selected item
    const localized = checkedBoxes.map(checkbox => {
      const label = document.querySelector(`label[for="${checkbox.id}"]`);
      return label ? label.innerText : null;
    });

    const pendingValues = checkedBoxes.map(checkbox => checkbox.value);
    const includesOther = pendingValues.includes('other');

    // 4. Validate "Other" text input if "other" checkbox is checked
    if (includesOther && !textInput) {
      // eslint-disable-next-line no-alert
      const continueSave = confirm(
        'Työvaiheen "Odottaa yhtiöstä" kenttä "Muu" on tyhjä. Haluatko varmasti jatkaa?'
      );
      if (!continueSave) return;
    }

    // 5. Construct payload object
    const items = {
      pending_from_client: pendingValues,
      pending_from_client__localized: localized,
      pending_from_client_date: new Date().toISOString().split('T')[0],
      ...(includesOther && {pending_from_client_other: textInput}),
    };

    this.itemDebouncer.push(items);

    // 6. Asynchronous Status Updates via Promise chaining + UI updates
    // a. Step update => pending_from_client / waiting_for_documents => COMPLETE
    this.item.updateStatus('pending_from_client', 'waiting_for_documents', 'COMPLETE')
      .then(stepResult => {
        if (stepResult.status !== 'OK') {
          this._showInfo(stepResult.messages, 'error');
          return Promise.reject(new Error('Step update failed')); // Cleanly aborts downstream .then handlers
        }

        // UI update (step)
        this._updateStepStatus('pending_from_client', 'waiting_for_documents', 'COMPLETE');

        // b. Stage update => pending_from_client => INCOMPLETE
        return this.item.updateStatus('pending_from_client', '', 'INCOMPLETE');
      })
      .then(stageUpdateResult => {
        if (stageUpdateResult && stageUpdateResult.status === 'OK') {
          // UI update (stage)
          this._updateStepStatus('pending_from_client', '', 'INCOMPLETE');

          // c. Update DOM element for last requested date on successful API update
          const lastRequestedDateElement = document.querySelector('.last-requested-date');
          if (lastRequestedDateElement && items.pending_from_client_date) {
            const formattedDate = new Date().toLocaleDateString('fi-FI', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
            lastRequestedDateElement.textContent = `Tiedot pyydetty viimeksi: ${formattedDate}`;
          }
        }
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error('Error updating status:', err);
      });
  }

  /**
   * Used to check if elements with `data-required` have a value.
   * Usually we would use the standard `required` -attr, but the actual saved values on
   * "Tarkista Kohteen Tiedot" -page are not directly associated with input elements.
   *
   * @returns {Array} - List of elements, that should contain a required field value, but don't.
   */
  _getMissingRequiredFields() {
    const requiredFields = document.querySelectorAll('[data-required]');
    const missingFields = Array.from(requiredFields).filter(el => !this._isRequiredFieldValid(el));
    return missingFields;
  }

  /**
   * @param {HTMLElement} element - The element to check
   * @returns {Boolean}
   */
  _isRequiredFieldValid(element) {
    switch(element.tagName) {
      case 'SELECT':
        return element.value.length > 0;
      case 'INPUT':
        return element.value !== '';
      default:
        return element.innerText.trim() !== ''
    }
  }

  _fetchAutovistaData(event) {
    const button = event.currentTarget;
    button.disabled = true;
    this._triggerClearInfoEvent();

    this.item.atj().then(result => {
      if (result.status === 'OK') {
        // Refresh view
        location.reload();
      } else {
        this._showInfo(result.messages, 'error');
        button.disabled = false;
      }
    });
  }

  _fetchTrafiVehicleData(event) {
    const button = event.currentTarget;
    button.disabled = true;
    this._triggerClearInfoEvent();

    this.item.trafiVehicle().then(result => {
      if (result.status === 'OK') {
        // Refresh view
        location.reload();
      } else {
        this._showInfo(result.messages, 'error');
        button.disabled = false;
      }
    });
  }

  /**
   * Handles the event of changing the value of an input inside a stage.
   * To prevent making AJAX requests for each character the user types,
   * the request is made only after the user has stopped typing for a
   * certain amount of time specified in the variable `throttlingTime`.
   *
   * @param {Event} event - The change or input event of an input field
   */
  _handleInputChange(event) {
    // prevent user from sending item to webshop while updates are pending. Also: start button's loading animation
    this._toggleWebshopButton( false, true );

    // show confirmation dialog if user tries to leave while updates are pending
    this.confirmLeaving.activate();

    const inputEl = event.delegateTarget || event.currentTarget;
    const field = inputEl.getAttribute('data-field');

    // Mirror radio selection state to steps with the same field name
    if(inputEl.type === 'radio') {
      document.querySelectorAll(`input[type="radio"][data-field="${ field }"][value="${ inputEl.value }"]`)
        .forEach(clone => clone.checked = true);
      // Get the radio's label text for localized logs:
      const label = document.querySelector(`label[for="${ inputEl.id }"]`);
      this.itemDebouncer.push({
        [field]: inputEl.value,
        [`${field}__localized`]: label ? label.innerText : null
      });
      return;
    }
    // Mirroring date fields need extra attention due to flatpickr;
    if(inputEl.type === 'hidden' && inputEl.classList.contains('flatpickr-input')) {
      const textValue = inputEl.nextElementSibling.value;
      document.querySelectorAll(`input[type="hidden"][data-field="${ field }"]`).forEach(clone => {
        clone.value = inputEl.value;
        clone.nextElementSibling.value = textValue;
      });
      this.itemDebouncer.push({ [field]: inputEl.value });
      return;
    }
    // Hidden, non flatpickr -inputs may have localized label field;
    if(inputEl.type === 'hidden') {
      const value = inputEl.value;
      const localized = document.querySelector(`label[for="${inputEl.id}"]`);
      this.itemDebouncer.push({
        [field]: value,
        [`${field}__localized`]: localized ? localized.innerText.trim() : null
      });
      return;
    }

    // Turn checkboxes into arrays before pushing
    if(inputEl.type === 'checkbox') {
      const checkedBoxes = Array.from(document.querySelectorAll(`[data-field="${ field }"]`))
        .filter(checkbox => checkbox.checked);
      const localized = checkedBoxes.map(checkbox => {
        const label = document.querySelector(`label[for="${checkbox.id}"]`);
        return label ? label.innerText : null
      });

      this.itemDebouncer.push({
        [field]: checkedBoxes.map(checkbox => checkbox.value),
        [`${field}__localized`]: localized
      });
      return;
    }

    this.itemDebouncer.push({
      [field]: inputEl.value
    })
  }

  /**
   * Clears the actual date input value, if flatpickr input is cleared
   * @param {Event} event - The event object
   */
  _handleFlatpickrChange(event) {
    if(event.target.value === '') {
      const dateInput = event.target.parentElement.querySelector('.date-picker__input[data-field]');
      if(!dateInput) return;
      if(dateInput.value === '') return;
      // eslint-disable-next-line no-alert
      if(!confirm(this.confirmClearDateMessage)) {
        // Hidden field has different format, convert from YYYY-MM-DD => DD.MM.YYYY
        event.target.value = new Date(dateInput.value).toLocaleDateString('fi-FI', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        return;
      }
      dateInput.value = '';
      triggerEvent(dateInput, 'change');
    }
  }

  /**
   * Updates the status of steps according to a response from the server
   *
   * @param {Object} response The server's response to the recently made PATCH /item/:pid request
   */
  _updateStepStatuses(response) {
    if (response.result && response.result.updatedStatuses) {
      // Updated statuses were found
      response.result.updatedStatuses.forEach(updatedStatus => this._updateStepStatus(updatedStatus.stage, updatedStatus.step, updatedStatus.status), this);
    }

    //Update also webstore btn
    if (response.result && typeof response.result.isSalable === 'boolean') {
      this._toggleWebshopButton( response.result.isSalable, false );
    }
  }

  /**
   * Updates the status of a single step
   *
   * @param {string} stage  The stage where this step is located
   * @param {string} step   The step that has an updated status
   * @param {string} status The new status
   */
  _updateStepStatus(stage, step, status) {
    const stepStatusClassPrefix = step ? 'steps__step--' : 'process-box__status--';
    const stepElement = step
      ? document.querySelector('[data-stage="' + stage + '"] [data-step="' + step + '"]')
      : document.querySelector('[data-stage="' + stage + '"] .process-box__status');

    if(stepElement) {
      // Remove previous status classes
      Array.from(stepElement.classList)
        .filter(className => className.indexOf(stepStatusClassPrefix) === 0)
        .forEach(className => stepElement.classList.remove(className));

      const statusClass = (stage === 'cabas' && status === 'INCOMPLETE') ? 'error' : status.toLowerCase()
      // Add new status
      stepElement.classList.add(stepStatusClassPrefix + statusClass);

      // Prepare the custom event
      let eventTarget = stepElement;
      let eventType;

      if(!step) { // Subject is an entire stage
        eventTarget = document.querySelector(`[data-stage="${ stage }"]`);
        eventType = status === 'COMPLETE' ? 'stage:complete' : 'stage:incomplete';

        // Set stage icon
        stepElement.innerHTML = svgIcons(status === 'COMPLETE' ? 'check' : (stage === 'cabas') ? 'error' : 'warning');

        // Hide/unhide stage status buttons
        document.querySelector(`[data-uncomplete-stage="${stage}"]`).classList.toggle('hidden', status !== 'COMPLETE');
        document.querySelector(`[data-complete-stage="${stage}"]`).classList.toggle('hidden', status === 'COMPLETE');

      } else { // Subject is a single step
        eventType = status === 'COMPLETE' ? 'step:complete' : 'step:incomplete';
      }

      // Create and trigger the custom event
      const event = new CustomEvent(eventType, {
        bubbles: true, detail: { stage, step }
      });
      eventTarget.dispatchEvent(event);
    }
  }

  /**
   * Handles the event of clicking the "complete stage" button.
   *
   * @param {Event} event - The click event of the button
   */
  _completeStageHandler(event) {
    this._completeStage(event.delegateTarget.getAttribute('data-complete-stage'));
  }

  /**
   * Changes the status the whole stage as completed.
   *
   * @param {string} stage The id of the stage to complete
   */
  _completeStage(stage) {
    this._triggerClearInfoEvent();
    const updateStepStatus = this._updateStepStatus.bind(this);
    this.item.updateStatus(stage, '', 'COMPLETE').then(result => {
      if (result.status === 'OK') {
        updateStepStatus(stage, '', 'COMPLETE');
      } else {
        this._showInfo(result.messages, 'error');
      }
    });
  }

  /**
   * Handles the event of clicking the "uncomplete stage" button.
   *
   * @param {Event} event - The click event of the button
   */
  _uncompleteStageHandler(event) {
    this._uncompleteStage(event.delegateTarget.getAttribute('data-uncomplete-stage'));
  }

  /**
   * Changes the status the whole stage as not started.
   *
   * @param {string} stage The id of the stage to uncomplete
   */
  _uncompleteStage(stage) {
    this._triggerClearInfoEvent();

    const updateStepStatus = this._updateStepStatus.bind(this);
    this.item.updateStatus(stage, '', 'INCOMPLETE').then(result => {
      if (result.status === 'OK') {
        updateStepStatus(stage, '', 'INCOMPLETE');
      } else {
        this._showInfo(result.messages, 'error');
      }
    });
  }

  /**
   * Handles populating a default value into the previous input
   *
   * @param {Event} event - The click event of the button
   */
  _handleDefaultValueClick(event) {
    const button = event.delegateTarget || event.currentTarget;
    const defaultValue = button.dataset.defaultValue;
    const target = document.getElementById(button.dataset.defaultFor);
    if(!defaultValue || !target) return;
    target.value = defaultValue;
    triggerEvent(target, 'input');
  }

  /**
   * Updates key amount to warehouse (deliveries)
   *
   * @param {Event} event - change, keyup etc event of the input
   */
  _handleWarehouseKeysChange(event) {
    const target = event.currentTarget;
    const amount = target.value;
    const deliveryPid = target.getAttribute('data-delivery');

    window.clearTimeout(this._throttleWarehouseKeysChange);

    this._triggerClearInfoEvent();

    this._throttleWarehouseKeysChange = window.setTimeout(() => {

      if(!this.delivery) {
        this.delivery = new Delivery(deliveryPid);
      }

      this.delivery.patch({number_of_keys_received: amount}).then(result => {
        if(result.status === 'OK') {
          this._autoUpdate('number_of_keys_received', amount);
        } else {
          this._showInfo(result.messages, 'error');
        }
      }, reason => {
        this._showInfo(reason, 'error');
      });

    }, this.throttleTime);

  }

  /**
   * Updates html elements that have data-auto-update attributes with corresponding fields as values
   * E.g. basic info box has amount of keys that needs to be updated when patch succeeds
   * <span data-auto-update="number_of_keys_received">1</span> value is updated whenever the input field changes
   *
   * @param {string} field - Which field was updated
   * @param {mixed} value  - New value of the field
   */
  _autoUpdate(field, value) {
    const targets = document.querySelectorAll('[data-auto-update="' + field + '"]');
    Array.from(targets).forEach(element => {
      element.innerText = value;
    });
  }

  /**
   * Toggle "Send to webshop" button(s) enabled/disabled.
   * This must be used when updatates to item are pending.
   * Can also be used to toggle fading animation of button.
   *
   * @param {boolean} state - true enables, false disables
   * @param {boolean} loadingState - enable/disable fade animation of button.
   */
  _toggleWebshopButton( state, loadingState ){
    document.querySelectorAll('.js-send-item-to-webshop').forEach(item => {
      if( state !== undefined ) item.disabled = !state;
      if( loadingState !== undefined ) item.classList.toggle( 'throbber', loadingState );
    });
  }

  /**
   * Handles the change event for the 'shouldRefresh' property in the response object
   * from API. If the response indicates that a refresh is needed, displays a notification
   * with a refresh button to the user.
   *
   * @param {Object} response - The response object containing the result.
   * @param {Object} response.result - The result object from the response.
   * @param {boolean} response.result.shouldRefresh - Indicates whether the page should be refreshed.
   */
  _handleShouldRefreshChange(response) {
    if (response.result && response.result.shouldRefresh) {
      this._showInfo('Kohteen tiedot on päivitetty. Päivitä sivu.', 'notification', true);
    }
  }

}

export default ItemView;
